import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import * as firebase from "firebase";
// import moment from "moment";

import "bootstrap/dist/css/bootstrap.min.css";
import "@/assets/css/main.css";

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: "AIzaSyCNjPQk2UdaGZUMU4koN6vrzu_cfRCCbVU",
  authDomain: "tsiklauri-app.firebaseapp.com",
  databaseURL:
    "https://tsiklauri-app-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "tsiklauri-app",
  storageBucket: "tsiklauri-app.appspot.com",
  messagingSenderId: "1000973461332",
  appId: "1:1000973461332:web:342e844e4cffc121418ac1",
  measurementId: "G-SZC4NW1770"
};

firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  render: (h) => h(App)
}).$mount("#app");
